import React, { useEffect, useState } from "react";
import { action, API, controller } from "../../../../../api/api";
import TabBar from "../../../../../controls/TabBar";
import { formatDate, useFormatPrice } from "hooks";

const Returns = ({ value, setActiveOn, setReturnSale }) => {
  const formatPrice = useFormatPrice();
  const [returns, setReturns] = useState([]);

  useEffect(() => {
    API(controller.SellReturn + action.GetReturnsBySellId).getById(
      value.id,
      (res) =>
        res.status === 200 &&
        setReturns([
          ...res.result.map((item, ind) => ({
            ...item,
            label: (
              <div className="flex flex-col text-left">
                <span className="">
                  {res.result.length > 1 ? `${ind + 1}/` : ""} Return Sale (
                  {formatPrice(item.refundAmt)})
                </span>
                <span className="text-[12px] text-gray-500">
                  {formatDate(value.returnDate)}
                </span>
              </div>
            ),
          })),
        ])
    );

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleSwitch = (val) => {
    // Id 0 means, Primary Sale
    if (val && val.id === 0) setActiveOn("primarySale");
    // This will condition is for the return sale.
    else if (val && val.id > 0) {
      setActiveOn("returnSale");
      setReturnSale({ ...val });
    }
  };

  return (
    <div>
      <TabBar
        onClick={handleSwitch}
        options={[
          {
            id: 0,
            label: (
              <div className="flex flex-col text-left">
                <span className="font-medium text-gray-700">
                  Primary Sale ({formatPrice(value.netPayable)})
                </span>
                {value.sellDate && (
                  <span className="text-[12px] text-gray-500">
                    {formatDate(value.sellDate)}
                  </span>
                )}
              </div>
            ),
          },
          ...returns,
        ]}
      />
    </div>
  );
};

export default Returns;
